// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"HomeScreen_titleWrapper__1TfU6","chartWrapper":"HomeScreen_chartWrapper__6mDKM"};